"use strict";
exports.isSameWeek = isSameWeek;
var _index = require("./startOfWeek.js");
function isSameWeek(dateLeft, dateRight, options) {
  const dateLeftStartOfWeek = (0, _index.startOfWeek)(dateLeft, options);
  const dateRightStartOfWeek = (0, _index.startOfWeek)(dateRight, options);
  return +dateLeftStartOfWeek === +dateRightStartOfWeek;
}
